import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

function Input({ type, name, placeholder, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <input
        type={type}
        ref={inputRef}
        className={error ? 'erro' : ''}
        placeholder={error || placeholder}
        {...rest}
      />
    </>
  );
}

export default Input;
